import type { AreaKind, AreaOptionsValue } from './components/area-options';
import type { PlaceResult } from './components/place-autocomplete';

/** World, country or state for a whole-area pick; null for streets around a point */
export function areaKind(place: PlaceResult | null): AreaKind | null {
  if (!place?.areaType) return null;
  if (place.areaType === 'world') return 'world';
  return place.areaType === 'country' ? 'country' : 'state';
}

/** The map-poster Lambda's area params for the chosen options */
export function areaRequestParams(place: PlaceResult, options: AreaOptionsValue) {
  return {
    area_type: place.areaType,
    area_name: place.areaName,
    country_code: place.countryCode,
    road_detail: options.roadDetail,
    show_boundaries: options.showBoundaries,
    colour_states: options.colourStates,
    grid: options.grid,
    labels: options.labels.length ? options.labels : undefined,
    show_cities: options.showCities,
  };
}

/** The options as saved in the cart line's config, which deck sends again for the print */
export function areaConfig(areaId: string, options: AreaOptionsValue) {
  return {
    areaId,
    roadDetail: options.roadDetail,
    showBoundaries: options.showBoundaries,
    colourStates: options.colourStates,
    grid: options.grid,
    labels: options.labels.length ? options.labels : undefined,
    showCities: options.showCities,
  };
}

/** The world is drawn landscape on the portrait sizes (deck turns it onto the portrait sheet): its preview box too */
export function previewAspect(place: PlaceResult | null, aspect: string): string {
  const [width, height] = aspect.split('/').map(Number);
  return place?.areaType === 'world' && width < height ? `${height}/${width}` : aspect;
}

/** "Kerala, India (whole state)", "The World (whole world)" or "Paris, France (4km radius)" */
export function mapSummary(place: PlaceResult, city: string, country: string, distance: number): string {
  const kind = areaKind(place);
  const name = [city, country].filter(Boolean).join(', ');
  return `${name} (${kind ? `whole ${kind}` : `${Math.round(distance / 1000)}km radius`})`;
}
